import Button from '../common/Button'

interface DeleteConfirmModalProps {
  targetEmail: string
  onClose: () => void
  onConfirm: () => void
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({ targetEmail, onClose, onConfirm }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="px-6 py-4">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
            Confirm Deletion
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Are you sure you want to remove <span className="font-medium text-gray-900 dark:text-white">{targetEmail}</span> from the target pool?
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
            This action cannot be undone.
          </p>
        </div>

        <div className="px-6 py-4 bg-gray-50 dark:bg-gray-700 flex gap-3 rounded-b-lg">
          <Button
            variant="secondary"
            onClick={onClose}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            className="flex-1"
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  )
}

export default DeleteConfirmModal
